var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1760_6422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29609 16.0937C8.38351 16.0063 8.5037 15.9553 8.63119 15.9553H20.1921C20.4033 15.9553 20.509 16.2103 20.3596 16.3596L18.0759 18.6434C17.9884 18.7308 17.8682 18.7818 17.7408 18.7818H6.17987C5.96861 18.7818 5.86298 18.5268 6.01232 18.3775L8.29609 16.0937Z",
    fill: "url(#paint0_linear_1760_6422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29609 7.56688C8.38715 7.47946 8.50735 7.42847 8.63119 7.42847H20.1921C20.4033 7.42847 20.509 7.68343 20.3596 7.83277L18.0759 10.1165C17.9884 10.204 17.8682 10.2549 17.7408 10.2549H6.17987C5.96861 10.2549 5.86298 9.99998 6.01232 9.85064L8.29609 7.56688Z",
    fill: "url(#paint1_linear_1760_6422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0759 11.8032C17.9884 11.7158 17.8682 11.6648 17.7408 11.6648H6.17987C5.96861 11.6648 5.86298 11.9198 6.01232 12.0691L8.29609 14.3529C8.38351 14.4403 8.5037 14.4913 8.63119 14.4913H20.1921C20.4033 14.4913 20.509 14.2363 20.3596 14.087L18.0759 11.8032Z",
    fill: "url(#paint2_linear_1760_6422)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1760_6422",
    x1: 19.0877,
    y1: 6.06427,
    x2: 11.0866,
    y2: 21.3895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1760_6422",
    x1: 15.5892,
    y1: 4.2377,
    x2: 7.58812,
    y2: 19.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1760_6422",
    x1: 17.3273,
    y1: 5.14539,
    x2: 9.32623,
    y2: 20.4706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1760_6422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4857,
    height: 11.3533,
    fill: "white",
    transform: "translate(5.94336 7.42847)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.378c9f6998b3d28a7628cae199c34cab.svg";
export { ForwardRef as ReactComponent };